import React, { Component }      from 'react'
import {connect}                 from 'react-redux';
import { GetRegistroAlunoTurma } from '../../../actions/usuarioAction';
import AlunosListGruposturmas    from '../../../container/renderListAvatarAlunos';
import {SetError}                from '../../../actions/notificacaoAction';
import FlashCarregando           from '../../../container/FlashCarregando';


class Turma_Aluno_Lista extends Component {

    constructor(props){
        super(props);
        this.state = {load:false,tur_nome:"carregando..."}
            
    }
   
    componentWillMount(){

        this.props.GetRegistroAlunoTurma(this.props.tur_id).then((response)=>{
            this.setState({load:true});
        }).catch((error)=>{
            this.props.SetError(500);
        })    

        if (this.props.allPostsTurma) {
        this.setState({tur_nome:this.props.allPostsTurma.tur_nome});
        }
    }
    
    render() {
  
        var lista  = (this.props.listaAlunos.length) ?

       <div className="panel panel-azul-claro panel-cinza">
                            <div className="panel-body panel-body-lista-alunos">
                            {!this.props.listaAlunos ? "" : <AlunosListGruposturmas dadosUser = {this.props.listaAlunos}/>}
                            </div>
                            </div>:
            
    
                            <p>Não existe aluno cadastrado nesta turma.</p>;
        


        return (

            <div>
                { this.state.load ? lista  : <FlashCarregando/>}
            </div>
            
        )
    }
}

function mapStateToProps(state){

    return{

         session       : state.auth.session,
         listaAlunos   : state.usuarioReducer.allUsuariosTurma,
         allPostsTurma : state.turmaReducer.turma
    }
}

export default connect(mapStateToProps,{GetRegistroAlunoTurma,SetError})(Turma_Aluno_Lista);



// WEBPACK FOOTER //
// ./src/components/professor/timeline_turma/turma_alunos_lista.js